import { colors } from '@assets/colors';
import { IPerformanceProduto } from '@core/models';
import { formatCurrency, isFilled } from '@core/utils';
import { CompareArrows } from '@mui/icons-material';
import { Box, Button, Container, Divider, Typography } from '@mui/material';
import { useState } from 'react';
import placeholderImagemProduto from '@assets/shoe-placeholder.jpg';

interface IPerformanceProdutoProps {
    produto: IPerformanceProduto | null;
}

export const PerformanceProduto: React.FC<IPerformanceProdutoProps> = ({ produto }) => {
    const [compararCom, setCompararCom] = useState<string>('empresa');

    const handleComparacao = (comparacao: string) => {
        setCompararCom(comparacao);
    };

    const urlImagemProduto = isFilled(produto?.urlImagemProduto) ? produto?.urlImagemProduto : placeholderImagemProduto;

    return (
        <Container maxWidth="sm" sx={{ px: 0 }}>
            <Box display="flex" justifyContent="center" flexDirection="column" justifyItems="center" border={'1px solid' + colors.gray3} borderRadius="4px" px="24px" mb="24px" gap="8px">
                <img srcSet={`${urlImagemProduto}`} src={`${urlImagemProduto}`} alt={produto?.descricao} loading="lazy" />
            </Box>
            <Box display="flex" justifyContent="center" flexDirection="column" justifyItems="center" gap="12px">
                <Typography variant="body1" fontSize="17px" fontWeight="600">
                    {produto?.descricao}
                </Typography>
                <Typography variant="body1" fontSize="14px">
                    SKU: <span style={{ fontWeight: 600 }}>{produto?.loja?.centro}</span>
                </Typography>
                <Typography variant="body1" fontSize="14px">
                    Curva: <span style={{ fontWeight: 600 }}>{produto?.curvaAbc}</span>
                </Typography>
            </Box>
            <Divider sx={{ py: '10px' }} />
            <Box sx={{ display: 'flex', marginTop: '24px' }}>
                <Box width="50%" display="flex" flexDirection="column" gap="10px">
                    <Typography variant="body1" fontSize="17px" fontWeight="600">
                        Loja
                    </Typography>
                    <Typography variant="body1" fontSize="14px">
                        Valor da venda:
                        <span style={{ fontWeight: 600, display: 'block' }}>{formatCurrency(Number(produto?.loja?.vendaValor))}</span>
                    </Typography>
                    <Typography variant="body1" fontSize="14px">
                        Estoque de Peças: <span style={{ fontWeight: 600 }}>{produto?.loja?.estoquePecas}</span>
                    </Typography>
                    <Typography variant="body1" fontSize="14px">
                        Giro de Peças: <span style={{ fontWeight: 600 }}>{produto?.loja?.giroPecas}</span>
                    </Typography>
                    <Typography variant="body1" fontSize="14px">
                        Centro: <span style={{ fontWeight: 600 }}>{produto?.loja?.centro}</span>
                    </Typography>
                    <Typography variant="body1" fontSize="14px">
                        Regional: <span style={{ fontWeight: 600 }}>{produto?.loja?.regional}</span>
                    </Typography>
                </Box>
                <Divider orientation="vertical" variant="middle" flexItem />
                {compararCom === 'regional' ? (
                    <Box width="50%" sx={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingLeft: '10px' }}>
                        <Typography variant="body1" fontSize="17px" fontWeight="600">
                            Regional
                        </Typography>
                        <Typography variant="body1" fontSize="14px">
                            Valor da venda: <span style={{ fontWeight: 600, display: 'block' }}>{formatCurrency(Number(produto?.regional?.vendaValor))}</span>
                        </Typography>
                        <Typography variant="body1" fontSize="14px">
                            Estoque de Peças: <span style={{ fontWeight: 600 }}>{produto?.regional?.estoquePecas}</span>
                        </Typography>
                        <Typography variant="body1" fontSize="14px">
                            Giro de Peças: <span style={{ fontWeight: 600 }}>{produto?.regional?.giroPecas}</span>
                        </Typography>
                        <Box>
                            <Button variant="contained" size="small" sx={{ mt: '18px' }} startIcon={<CompareArrows />} onClick={() => handleComparacao('empresa')}>
                                Empresa
                            </Button>
                        </Box>
                    </Box>
                ) : (
                    <Box width="50%" sx={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingLeft: '10px' }}>
                        <Typography variant="body1" fontSize="17px" fontWeight="600">
                            Empresa
                        </Typography>
                        <Typography variant="body1" fontSize="14px">
                            Valor da venda: <span style={{ fontWeight: 600, display: 'block' }}>{formatCurrency(Number(produto?.empresa?.vendaValor))}</span>
                        </Typography>
                        <Typography variant="body1" fontSize="14px">
                            Estoque de Peças: <span style={{ fontWeight: 600 }}>{produto?.empresa?.estoquePecas}</span>
                        </Typography>
                        <Typography variant="body1" fontSize="14px">
                            Giro de Peças: <span style={{ fontWeight: 600 }}>{produto?.empresa?.giroPecas}</span>
                        </Typography>
                        <Box>
                            <Button variant="contained" size="small" sx={{ mt: '18px' }} startIcon={<CompareArrows />} onClick={() => handleComparacao('regional')}>
                                Regional
                            </Button>
                        </Box>
                    </Box>
                )}
            </Box>
        </Container>
    );
};
